





























































































import { Component, Vue } from 'vue-property-decorator';
import { PageOption } from '@/@types/LibraryComponent';
import RecruitmentNavigationDrawer from '@/components/recruitment/RecruitmentNavigationDrawer.vue';
import CandidateAll from '@/components/recruitment/candidates/CandidateAll.vue';
import CandidateNotCompatible from '@/components/recruitment/candidates/CandidateNotCompatible.vue';
import CandidateDuringCorrespondence from '@/components/recruitment/candidates/CandidateDuringCorrespondence.vue';
import CandidateFinishedCorrespondence from '@/components/recruitment/candidates/CandidateFinishedCorrespondence.vue';

@Component({
  components: {
    RecruitmentNavigationDrawer,
    CandidateAll,
    CandidateNotCompatible,
    CandidateDuringCorrespondence,
    CandidateFinishedCorrespondence,
  },
})
export default class CandidateListBase extends Vue {
  private headers = [
    {
      text: '',
      align: 'start',
      sortable: false,
      value: 'icon',
    },
    { text: '名前', value: 'name' },
    { text: '職種', value: 'occupation' },
    { text: '案件名', value: 'matter' },
    { text: 'ステータス', value: 'status' },
    { text: 'メッセージ', value: 'message' },
  ];

  private occupations: Array<string> = [
    'エンジニア',
    'フロントエンドエンジニア',
    'バックエンドエンジニア',
    'インフラエンジニア',
    'データサイエンスエンジニア',
    'iOS/Androidアプリエンジニア',
    'プロジェクトリーダー',
    'プロジェクトマネージャー',
    'デザイナー',
    'マーケティング',
    'ライター',
    'セールス',
    'コーポレートスタッフ',
    'その他',
  ];

  private sorts: Array<string> = ['応募が新しい順', '応募が古い順', '更新日時が新しい順', '更新日時が古い順'];

  private menuContentFields = [
    {
      tabTitle: 'allCandidate',
      viewTitle: 'candidateAll',
    },
    {
      tabTitle: 'notCompatibleCandidates',
      viewTitle: 'candidateNotCompatible',
    },
    {
      tabTitle: 'duringCorrespondenceCandidates',
      viewTitle: 'candidateDuringCorrespondence',
    },
    {
      tabTitle: 'finishedCorrespondenceCandidate',
      viewTitle: 'candidateFinishedCorrespondence',
    },
  ];

  private candidateListDate = {
    candidateAll: 'candidateAll',
    candidateNotCompatible: 'candidateNotCompatible',
    candidateDuringCorrespondence: 'candidateDuringCorrespondence',
    candidateFinishedCorrespondence: 'candidateFinishedCorrespondence',
  };

  private selectedColor: string = 'primary';

  private view: string = 'candidateAll';

  private pageOption: PageOption = {
    count: 10,
    max: 5,
    min: 1,
    current: 1,
  };

  private components: Array<
    | typeof CandidateAll
    | typeof CandidateNotCompatible
    | typeof CandidateDuringCorrespondence
    | typeof CandidateFinishedCorrespondence
  > = [CandidateAll, CandidateNotCompatible, CandidateDuringCorrespondence, CandidateFinishedCorrespondence];

  private componentIndex: {
    candidateAll: number;
    candidateNotCompatible: number;
    candidateDuringCorrespondence: number;
    candidateFinishedCorrespondence: number;
  } = {
    candidateAll: 0,
    candidateNotCompatible: 1,
    candidateDuringCorrespondence: 2,
    candidateFinishedCorrespondence: 3,
  };

  private onChangeView(tabTitle: string): void {
    this.menuContentFields.forEach((v) => {
      if (tabTitle === v.tabTitle) {
        this.view = v.viewTitle;
      }
    });
  }

  private get candidateViewComponent() {
    switch (this.view) {
      case this.candidateListDate.candidateAll:
        return this.components[this.componentIndex.candidateAll];
      case this.candidateListDate.candidateNotCompatible:
        return this.components[this.componentIndex.candidateNotCompatible];
      case this.candidateListDate.candidateDuringCorrespondence:
        return this.components[this.componentIndex.candidateDuringCorrespondence];
      case this.candidateListDate.candidateFinishedCorrespondence:
        return this.components[this.componentIndex.candidateFinishedCorrespondence];
    }
  }
}
